import * as Yup from 'yup'
import { ParametroType } from '../../../../../../_metronic/helpers'
import { IOption } from '../../../../../components'

export const gerarDocumentoSchema = (isEdit: boolean, hasCid: boolean) => {
  return Yup.object().shape({
    cid: hasCid ? Yup.object().nullable().notRequired() : Yup.string().trim().notRequired(),
    isEncaminhamento: Yup.boolean().notRequired(),
    motivo: Yup.string()
      .trim()
      .when(['isEncaminhamento'], {
        is: (isEncaminhamento: boolean) => isEncaminhamento && !isEdit,
        then: (schema) => schema.required('Motivo é obrigatório'),
        otherwise: (schema) => schema.notRequired(),
      }),
    texto: Yup.string()
      .trim()
      .when([], {
        is: () => isEdit,
        then: (schema) => schema.required('Texto é obrigatório'),
        otherwise: (schema) => schema.notRequired(),
      }),
    dataAtestado: Yup.string().when(['documento', 'isEncaminhamento'], {
      is: (documento: IOption<number> | undefined, encaminhamento: boolean) =>
        !isEdit && documento?.value !== 12 && !encaminhamento,
      then: (schema) => schema.required('Data do documento é obrigatória'),
      otherwise: (schema) => schema.notRequired(),
    }),
    documento: Yup.object().nullable().required('Selecione um documento'),
    parametros: Yup.array()
      .of(
        Yup.object().shape({
          nome: Yup.string().required(),
          tipoParametro: Yup.string().required(),
          rotulo: Yup.string().required(),
          value: Yup.lazy((_, { parent }) => {
            const tipo = parent?.tipoParametro
            const rotulo = parent?.rotulo || 'Valor'

            switch (tipo) {
              case ParametroType.Integer:
                return Yup.string()
                  .required(`${rotulo} é obrigatório`)
                  .test('is-integer', `${rotulo} deve ser um número inteiro`, (value) =>
                    value !== undefined && value !== '' ? /^-?\d+$/.test(value) : false
                  )
                  .test('is-positive', `${rotulo} deve ser um número positivo`, (value) =>
                    value !== undefined && value !== '' ? Number(value) > 0 : false
                  )

              case ParametroType.Number:
                return Yup.string()
                  .required(`${rotulo} é obrigatório`)
                  .test('is-number', `${rotulo} deve ser um número`, (value) =>
                    value !== undefined && value !== '' ? !isNaN(Number(value)) : false
                  )
                  .test('is-positive', `${rotulo} deve ser um número positivo`, (value) =>
                    value !== undefined && value !== '' ? Number(value) > 0 : false
                  )

              case ParametroType.Date:
                return Yup.string()
                  .typeError(`${rotulo} deve ser uma data válida`)
                  .required(`${rotulo} é obrigatório`)

              case ParametroType.Time:
                return Yup.string()
                  .typeError(`${rotulo} deve ser um horário válido`)
                  .required(`${rotulo} é obrigatório`)

              case ParametroType.Especialidade:
                return Yup.object().nullable().required(`${rotulo} é obrigatório`)

              case ParametroType.String:
              default:
                return Yup.string().required(`${rotulo} é obrigatório`)
            }
          }),
        })
      )
      .required('Parâmetros são obrigatórios'),
  })
}
